<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">

    <div class="filter my-3">
      <div class="filter-head">
        <h4>{{ group ? `طلاب مجموعة ${group.name}` : 'تفاصيل المجموعة' }} ({{ total }})</h4>
        <div class="buttons">
          <router-link v-if="group" :to="`/grades/${gradeSlug}/groups/${group.id}/whatsapp`" class="btn btn-success text-white">
            <i class="pi pi-whatsapp me-1"></i> واتساب
          </router-link>
          <router-link v-if="group" :to="`/grades/${gradeSlug}/groups/${group.id}/messages`" class="btn btn-secondary text-white">
            <i class="pi pi-envelope me-1"></i> رسائل الحجز
          </router-link>
          <button class="btn btn-outline-primary" @click="openBulkAddDialog">
            <i class="pi pi-users me-1"></i> إضافة جماعية
          </button>
          <button class="btn PrimaryButton" @click="openAddStudentDialog">
            <i class="pi pi-user-plus me-1"></i> إضافة طالب
          </button>
          <button v-if="selectedStudentIds.length > 0" class="btn btn-warning text-white" @click="openBulkMoveDialog">
            <i class="pi pi-arrow-right-arrow-left me-1"></i> نقل الطلاب المحددين ({{ selectedStudentIds.length }})
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-12 col-12">
          <div class="form-group">
            <label>ابحث</label>
            <input type="search" class="form-control" placeholder="ابحث بالاسم أو رقم ولي الأمر" v-model="word" @keyup="debounceFetch">
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>الجنس</label>
            <Dropdown v-model="gender" :options="genderList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchStudents()" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>حالة الحجز</label>
            <Dropdown v-model="reservationStatus" :options="statusList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchStudents()" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="d-flex">
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">Excel</label>
              <button type="button" class="btn btn-success px-3" @click="exportToExcel">
                <i class="pi pi-file-excel"></i>
              </button>
            </div>
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">PDF</label>
              <button type="button" class="btn btn-danger px-3" v-print="printOptions">
                <i class="pi pi-file-pdf"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>
                <input type="checkbox" :checked="allSelectedOnPage" :disabled="students.length === 0" @change="toggleSelectAll($event.target.checked)" />
              </th>
              <th>#</th>
              <th>رقم الحجز</th>
              <th>الطالب</th>
              <th>رقم ولي الأمر</th>
              <th>حالة الحجز</th>
              <th>التحكم</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="6" class="text-center py-4">
                <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;"></i>
              </td>
            </tr>
            <tr v-else-if="students.length === 0">
              <td colspan="6" class="text-center py-4 text-muted">لا يوجد طلاب في هذه المجموعة</td>
            </tr>
            <tr v-for="(s, index) in students" :key="s.id" v-else>
              <td>
                <input type="checkbox" :checked="selectedStudentIds.includes(s.user_id)" @change="toggleSelectStudent(s.user_id, $event.target.checked)" />
              </td>
              <td>{{ index + 1 }}</td>
              <td>{{ s.id }}</td>
              <td>{{ s.name }}</td>
              <td>{{ s.parent_phone }}</td>
              <td>
                <span v-if="s.reservation_status == 1" class="status-badge status-badge--accepted">مقبول</span>
                <span v-else-if="s.reservation_status == 2" class="status-badge status-badge--rejected">مرفوض</span>
                <span v-else-if="s.reservation_status == 3" class="status-badge status-badge--waiting">انتظار الشهادة</span>
                <span v-else class="status-badge status-badge--pending">معلق</span>
              </td>
              <td>
                <button class="btn btn-warning text-white mx-1" :tooltip="'نقل الطالب'" flow="up" @click="openMoveDialog(s)">
                  <i class="pi pi-arrow-right-arrow-left"></i>
                </button>
                <button class="btn btn-danger text-white mx-1" :tooltip="'إزالة من المجموعة'" flow="up" @click="removeStudent(s)">
                  <i class="pi pi-times"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div id="groupStudentsExportTable" class="print-only-table">
          <div class="print-export-header">
            <h1>طلاب مجموعة</h1>
            <h2>اسم المجموعة: {{ group?.name ?? '' }}</h2>
            <h2>عدد الطلاب: {{ students.length }}</h2>
          </div>
          <table class="print-export-table">
            <thead>
              <tr>
                <th>#</th>
                <th>رقم الحجز</th>
                <th>رقم الطالب</th>
                <th>الطالب</th>
                <th>رقم ولي الأمر</th>
                <th>حالة الحجز</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, index) in students" :key="s.id">
                <td>{{ index + 1 }}</td>
                <td>{{ s.id }}</td>
                <td>{{ s.phone }}</td>
                <td>{{ s.name }}</td>
                <td>{{ s.parent_phone }}</td>
                <td>{{ printStatusLabel(s.reservation_status) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>

  <!-- Add single student -->
  <Dialog v-model:visible="addDialogVisible" modal header="إضافة طالب" :style="{ width: '30rem' }">
    <div class="form-group d-flex flex-column">
      <label>ابحث عن طالب</label>
      <Dropdown
        v-model="selectedStudent"
        :options="availableStudents"
        optionLabel="name"
        filter
        :filterFields="['name', 'parent_phone']"
        placeholder="اختر طالباً"
        @filter="onAvailableFilter"
        class="w-100"
      >
        <template #option="slotProps">
          <span>{{ slotProps.option.name }} — {{ slotProps.option.parent_phone }}</span>
        </template>
      </Dropdown>
    </div>
    <div class="mt-3 text-end">
      <button class="btn PrimaryButton" :disabled="!selectedStudent || addingStudent" @click="addStudent">
        <i class="pi pi-spin pi-spinner-dotted" v-if="addingStudent"></i>
        {{ addingStudent ? 'جاري الإضافة...' : 'إضافة' }}
      </button>
    </div>
  </Dialog>

  <!-- Bulk add -->
  <Dialog v-model:visible="bulkDialogVisible" modal header="إضافة جماعية للطلاب" :style="{ width: '35rem' }">
    <div class="row g-2 mb-2">
      <div class="col-6">
        <div class="form-group d-flex flex-column">
          <label>الجنس</label>
          <Dropdown v-model="availableGender" :options="genderList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchAvailableStudents()" />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group d-flex flex-column">
          <label>حالة الحجز</label>
          <Dropdown v-model="availableReservationStatus" :options="statusList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchAvailableStudents()" />
        </div>
      </div>
    </div>
    <div class="form-group d-flex flex-column">
      <label>اختر الطلاب</label>
      <MultiSelect
        v-model="bulkSelectedStudents"
        :options="availableStudents"
        optionLabel="name"
        filter
        :filterFields="['name', 'parent_phone']"
        placeholder="اختر الطلاب"
        :maxSelectedLabels="3"
        class="w-100"
        @filter="onAvailableFilter"
      />
    </div>
    <div class="mt-3 text-end">
      <button class="btn PrimaryButton" :disabled="bulkSelectedStudents.length === 0 || bulkAdding" @click="bulkAddStudents">
        <i class="pi pi-spin pi-spinner-dotted" v-if="bulkAdding"></i>
        {{ bulkAdding ? 'جاري النقل...' : `نقل ${bulkSelectedStudents.length} طالب` }}
      </button>
    </div>
  </Dialog>

  <!-- Move single student -->
  <Dialog v-model:visible="moveDialogVisible" modal header="نقل الطالب" :style="{ width: '30rem' }">
    <div class="form-group d-flex flex-column mb-3">
      <label>المجموعة الحالية</label>
      <input type="text" class="form-control" :value="group?.name ?? ''" readonly disabled />
    </div>
    <div class="form-group d-flex flex-column">
      <label>المجموعة الوجهة</label>
      <Dropdown
        v-model="moveDestinationGroup"
        :options="destinationGroupOptions"
        optionLabel="label"
        placeholder="اختر المجموعة الوجهة"
        class="w-100"
        :loading="destinationGroupsLoading"
      />
      <small v-if="!destinationGroupsLoading && destinationGroupOptions.length === 0" class="text-muted mt-1">
        لا توجد مجموعات أخرى في نفس السنة الدراسية.
      </small>
    </div>
    <div class="mt-3 text-end">
      <button class="btn PrimaryButton" :disabled="!moveDestinationGroup || moving" @click="confirmMoveStudent">
        <i class="pi pi-spin pi-spinner-dotted" v-if="moving"></i>
        {{ moving ? 'جاري النقل...' : 'تأكيد النقل' }}
      </button>
    </div>
  </Dialog>

  <!-- Move selected students (bulk) -->
  <Dialog v-model:visible="bulkMoveDialogVisible" modal header="نقل الطلاب المحددين" :style="{ width: '30rem' }">
    <div class="form-group d-flex flex-column mb-3">
      <label>عدد الطلاب المحددين</label>
      <input type="text" class="form-control" :value="selectedStudentIds.length" readonly disabled />
    </div>
    <div class="form-group d-flex flex-column">
      <label>المجموعة الوجهة</label>
      <Dropdown
        v-model="bulkMoveDestinationGroup"
        :options="destinationGroupOptions"
        optionLabel="label"
        placeholder="اختر المجموعة الوجهة"
        class="w-100"
        :loading="destinationGroupsLoading"
      />
    </div>
    <p v-if="bulkMoveDestinationGroup" class="text-muted mt-2 mb-0">
      هل أنت متأكد من نقل {{ selectedStudentIds.length }} طالب إلى مجموعة {{ bulkMoveDestinationGroup.name }}؟
    </p>
    <div class="mt-3 text-end">
      <button class="btn PrimaryButton" :disabled="!bulkMoveDestinationGroup || bulkMoving" @click="confirmBulkMove">
        <i class="pi pi-spin pi-spinner-dotted" v-if="bulkMoving"></i>
        {{ bulkMoving ? 'جاري النقل...' : `نقل ${selectedStudentIds.length} طالب` }}
      </button>
    </div>
  </Dialog>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx/xlsx.mjs';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: 'GradeGroupShow',
  components: { Dialog, Dropdown, MultiSelect, Breadcrumb },

  data() {
    return {
      group: null,
      students: [],
      total: 0,
      loading: true,
      word: '',
      searchTimeout: null,
      gender: null,
      reservationStatus: null,
      genderList: [
        { id: 1, title: 'ولد' },
        { id: 2, title: 'بنت' },
      ],
      statusList: [
        { id: 1, title: 'مقبول' },
        { id: 0, title: 'معلق' },
        { id: 2, title: 'مرفوض' },
      ],

      availableStudents: [],
      availableWord: '',
      availableGender: null,
      availableReservationStatus: null,
      addDialogVisible: false,
      selectedStudent: null,
      addingStudent: false,

      bulkDialogVisible: false,
      bulkSelectedStudents: [],
      bulkAdding: false,

      // Row selection (for bulk move)
      selectedStudentIds: [],

      // Destination groups (same academic year, for both move dialogs)
      destinationGroups: [],
      destinationGroupsLoading: false,

      // Move single student
      moveDialogVisible: false,
      moveTargetStudent: null,
      moveDestinationGroup: null,
      moving: false,

      // Move selected students (bulk)
      bulkMoveDialogVisible: false,
      bulkMoveDestinationGroup: null,
      bulkMoving: false,
    };
  },

  computed: {
    gradeStore() { return useGradeStore(); },
    gradeSlug() { return this.$route.params.gradeSlug; },
    groupId() { return this.$route.params.groupId; },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'مجموعات الطلاب', path: `/grades/${this.gradeSlug}/groups` },
        { name: this.group?.name ?? 'المجموعة', path: `/grades/${this.gradeSlug}/groups/${this.groupId}` },
      ];
    },
    printOptions() {
      return {
        id: '#groupStudentsExportTable',
        popTitle: `طلاب مجموعة ${this.group?.name ?? ''}`,
      };
    },
    allSelectedOnPage() {
      return this.students.length > 0 && this.selectedStudentIds.length === this.students.length;
    },
    // Same academic year, current group excluded, with a "name (count)" label for the dropdown.
    destinationGroupOptions() {
      return this.destinationGroups
        .filter(g => String(g.id) !== String(this.groupId))
        .map(g => ({ ...g, label: `${g.name} (${g.students_count})` }));
    },
  },

  methods: {
    debounceFetch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.fetchStudents(), 800);
    },

    async fetchGroup() {
      const { data } = await axios.get(`/groups/${this.groupId}`);
      this.group = data.data;
    },

    async fetchStudents() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/groups/${this.groupId}/students`, {
          params: {
            word: this.word || undefined,
            gender: this.gender?.id,
            reservation_status: this.reservationStatus ? this.reservationStatus.id : undefined,
          },
        });
        this.students = data.data ?? [];
        this.total = this.students.length;
      } catch {
        this.students = [];
      } finally {
        this.loading = false;
      }
    },

    genderLabel(gender) {
      return gender == 2 ? 'بنت' : 'ولد';
    },

    statusLabel(status) {
      if (status == 1) return 'مقبول';
      if (status == 2) return 'مرفوض';
      if (status == 3) return 'انتظار الشهادة';
      return 'معلق';
    },

    // Separate from statusLabel() (still used by Excel export, unchanged) so
    // the PDF can use the exact wording requested for the PDF specifically
    // without altering the Excel output.
    printStatusLabel(status) {
      if (status == 1) return 'مقبول';
      if (status == 2) return 'مرفوض';
      if (status == 3) return 'في انتظار الشهادة';
      return 'معلق';
    },

    exportToExcel() {
      const rows = this.students.map(s => ({
        'اسم الطالب': s.name,
        'رقم ولي الأمر': s.parent_phone,
        'الجنس': this.genderLabel(s.gender),
        'حالة الحجز': this.statusLabel(s.reservation_status),
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'الطلاب');
      XLSX.writeFile(wb, `طلاب-${this.group?.name || 'مجموعة'}.xlsx`);
    },

    async fetchAvailableStudents(word) {
      try {
        const w = word !== undefined ? word : this.availableWord;
        const { data } = await axios.get(`/groups/${this.groupId}/available-students`, {
          params: {
            word: w || undefined,
            gender: this.availableGender?.id,
            reservation_status: this.availableReservationStatus ? this.availableReservationStatus.id : undefined,
          },
        });
        this.availableStudents = data.data ?? [];
      } catch {
        this.availableStudents = [];
      }
    },

    onAvailableFilter(e) {
      this.availableWord = e.value;
      this.fetchAvailableStudents();
    },

    openAddStudentDialog() {
      this.selectedStudent = null;
      this.availableWord = '';
      this.availableGender = null;
      this.availableReservationStatus = null;
      this.fetchAvailableStudents();
      this.addDialogVisible = true;
    },

    openBulkAddDialog() {
      this.bulkSelectedStudents = [];
      this.availableWord = '';
      this.availableGender = null;
      this.availableReservationStatus = null;
      this.fetchAvailableStudents();
      this.bulkDialogVisible = true;
    },

    async addStudent() {
      if (!this.selectedStudent) return;
      this.addingStudent = true;
      try {
        const { data } = await axios.post(`/groups/${this.groupId}/students`, {
          student_id: this.selectedStudent.id,
        });
        if (data.status) {
          Swal.fire('', data.message, 'success');
          this.addDialogVisible = false;
          this.fetchGroup();
          this.fetchStudents();
        } else {
          Swal.fire('', data.message, 'error');
        }
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ', 'error');
      } finally {
        this.addingStudent = false;
      }
    },

    async bulkAddStudents() {
      if (this.bulkSelectedStudents.length === 0) return;
      this.bulkAdding = true;
      try {
        const { data } = await axios.post(`/groups/${this.groupId}/students/bulk`, {
          student_ids: this.bulkSelectedStudents.map(s => s.id),
        });
        if (data.status) {
          Swal.fire('', data.message, 'success');
          this.bulkDialogVisible = false;
          this.fetchGroup();
          this.fetchStudents();
        } else {
          Swal.fire('', data.message, 'error');
        }
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ', 'error');
      } finally {
        this.bulkAdding = false;
      }
    },

    removeStudent(student) {
      Swal.fire({
        title: `إزالة "${student.name}" من المجموعة؟`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'إزالة',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        // student.id is now the reservation id (matches /all_reservations);
        // this endpoint expects the User id, which is student.user_id.
        axios.delete(`/groups/${this.groupId}/students/${student.user_id}`).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            this.fetchGroup();
            this.fetchStudents();
          }
        });
      });
    },

    toggleSelectAll(checked) {
      // selectedStudentIds feeds move-bulk, which validates against users.id
      // — must be user_id, not the (now reservation) id.
      this.selectedStudentIds = checked ? this.students.map(s => s.user_id) : [];
    },

    toggleSelectStudent(studentId, checked) {
      if (checked) {
        if (!this.selectedStudentIds.includes(studentId)) this.selectedStudentIds.push(studentId);
      } else {
        this.selectedStudentIds = this.selectedStudentIds.filter(id => id !== studentId);
      }
    },

    successToast(title) {
      Swal.mixin({
        toast: true, position: 'top-end',
        showConfirmButton: false, timer: 3000, timerProgressBar: true,
      }).fire({ icon: 'success', title });
    },

    async fetchDestinationGroups() {
      if (!this.group?.academic_year_id) return;
      this.destinationGroupsLoading = true;
      try {
        const { data } = await axios.get(`/academic-years/${this.group.academic_year_id}/groups`);
        this.destinationGroups = data.data ?? [];
      } catch {
        this.destinationGroups = [];
      } finally {
        this.destinationGroupsLoading = false;
      }
    },

    async openMoveDialog(student) {
      this.moveTargetStudent = student;
      this.moveDestinationGroup = null;
      this.moveDialogVisible = true;
      await this.fetchDestinationGroups();
    },

    async confirmMoveStudent() {
      if (!this.moveDestinationGroup || !this.moveTargetStudent) return;
      this.moving = true;
      try {
        // moveTargetStudent.id is now the reservation id — this endpoint
        // expects the User id, which is moveTargetStudent.user_id.
        const { data } = await axios.post(
          `/groups/${this.groupId}/students/${this.moveTargetStudent.user_id}/move`,
          { destination_group_id: this.moveDestinationGroup.id },
        );
        if (data.status) {
          this.moveDialogVisible = false;
          this.selectedStudentIds = this.selectedStudentIds.filter(id => id !== this.moveTargetStudent.user_id);
          this.fetchGroup();
          this.fetchStudents();
          this.successToast(data.message);
        } else {
          Swal.fire('', data.message, 'error');
        }
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ أثناء نقل الطالب', 'error');
      } finally {
        this.moving = false;
      }
    },

    async openBulkMoveDialog() {
      if (this.selectedStudentIds.length === 0) return;
      this.bulkMoveDestinationGroup = null;
      this.bulkMoveDialogVisible = true;
      await this.fetchDestinationGroups();
    },

    confirmBulkMove() {
      if (!this.bulkMoveDestinationGroup || this.selectedStudentIds.length === 0) return;
      const count = this.selectedStudentIds.length;
      const destinationName = this.bulkMoveDestinationGroup.name;

      Swal.fire({
        title: 'تأكيد النقل الجماعي',
        icon: 'warning',
        text: `هل أنت متأكد من نقل ${count} طالب إلى مجموعة ${destinationName}؟`,
        showCancelButton: true,
        confirmButtonText: 'تأكيد',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        this.bulkMoving = true;
        axios.post(`/groups/${this.groupId}/students/move-bulk`, {
          student_ids: this.selectedStudentIds,
          destination_group_id: this.bulkMoveDestinationGroup.id,
        }).then(({ data }) => {
          if (data.status) {
            this.bulkMoveDialogVisible = false;
            this.selectedStudentIds = [];
            this.fetchGroup();
            this.fetchStudents();
            this.successToast(`تم نقل ${data.moved} طالباً بنجاح.`);
          } else {
            Swal.fire('', data.message, 'error');
          }
        }).catch((error) => {
          Swal.fire('', error.response?.data?.message || 'حدث خطأ أثناء النقل الجماعي', 'error');
        }).finally(() => {
          this.bulkMoving = false;
        });
      });
    },
  },

  async mounted() {
    if (!this.gradeStore.activeGrades.length) {
      await this.gradeStore.fetchActiveGrades();
    }
    await this.fetchGroup();
    this.fetchStudents();
  },
};
</script>

<style scoped>
/* Export-only table: hidden on screen (it duplicates the visible table with
   Excel-matching columns), but must render for vue3-print-nb.
   IMPORTANT: this must be a stylesheet rule, not an inline style="display:none"
   on the element — vue3-print-nb clones the target node's outerHTML verbatim
   into the print document, so an inline display:none is copied along with it
   and stays in effect, leaving the printed page blank. A class-based rule
   overridden by @media print (like the app's other print pipelines) is
   overridden correctly because the print iframe also inherits this page's
   stylesheet rules.

   vue3-print-nb builds its print document by copying every rule from
   document.styleSheets into the print iframe's <head> (see getHead() in
   vue3-print-nb) — not just this component's own CSS. This app bundles all
   component styles into one global stylesheet, and grades/students.vue
   defines a page-wide (non-scoped, intentionally global) print rule:
   `@media print { body * { visibility: hidden !important; } #printReport,
   #printReport * { visibility: visible !important; } }`. That rule ships on
   every route, so it was also active here: once the table above stopped
   being display:none, it still inherited `visibility: hidden` from that
   unrelated rule (nothing on this page excepted it), which hid the table's
   content while still reserving its layout space — the "12 blank pages"
   symptom. This block below only ADDS an exception for this page's own
   print target; it does not modify grades/students.vue or its rule.

   The export target is now a <div> wrapping a title block + the table
   (rather than a bare <table>), so a page title can print above the data —
   `display: block` here, not `table`.
*/
.print-only-table {
  display: none;
}
@media print {
  .print-only-table {
    display: block !important;
  }
  #groupStudentsExportTable,
  #groupStudentsExportTable * {
    visibility: visible !important;
    /* Print-only readability: force pure black text everywhere in this
       export block (headers, body, title) regardless of the on-screen
       (light gray) theme colors — never touches the on-screen table. */
    color: #000 !important;
    font-family: 'Cairo', 'regular', Tahoma, Arial, sans-serif;
  }
  #groupStudentsExportTable {
    position: absolute;
    inset: 0;
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    /* Page margins (top 20mm / right 12mm / bottom 15mm / left 12mm) are
       applied as padding on this element rather than an @page rule.
       vue3-print-nb copies this whole app's bundled CSS into every print
       job, including grades/students.vue's own @page rule — an @page rule
       here would either fight that one (source-order dependent) or leak
       into other pages' print margins. Padding on this ID only ever
       affects this page's own export block. */
    padding: 20mm 12mm 15mm 12mm;
  }

  .print-export-header {
    text-align: center;
    margin-bottom: 6mm;
  }
  .print-export-header h1 {
    font-size: 18px;
    font-weight: bold;
    color: #000 !important;
    margin: 0 0 3mm;
  }
  .print-export-header h2 {
    font-size: 14px;
    font-weight: bold;
    color: #000 !important;
    margin: 0 0 1mm;
  }

  .print-export-table {
    width: 100%;
    border-collapse: collapse;
  }
  /* Repeat the header row on every printed page. */
  .print-export-table thead {
    display: table-header-group;
  }
  /* Never split a single row across a page break. */
  .print-export-table tr {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .print-export-table th,
  .print-export-table td {
    border: 1px solid #D1D5DB;
    color: #000 !important;
    padding: 8px 10px;
    line-height: 1.4;
  }
  .print-export-table th {
    font-size: 13px;
    font-weight: bold;
    color: #000 !important;
    background: #F3F4F6 !important;
  }
  .print-export-table td {
    font-size: 11px;
  }
  /* Alternating row colors: white / #FAFAFA. */
  .print-export-table tbody tr:nth-child(odd) td {
    background: #fff !important;
  }
  .print-export-table tbody tr:nth-child(even) td {
    background: #FAFAFA !important;
  }

  /* Alignment: #, رقم الطالب, حالة الحجز centered; الطالب, رقم ولي الأمر right-aligned. */
  .print-export-table th:nth-child(1),
  .print-export-table td:nth-child(1),
  .print-export-table th:nth-child(2),
  .print-export-table td:nth-child(2),
  .print-export-table th:nth-child(5),
  .print-export-table td:nth-child(5) {
    text-align: center;
  }
  .print-export-table th:nth-child(3),
  .print-export-table td:nth-child(3),
  .print-export-table th:nth-child(4),
  .print-export-table td:nth-child(4) {
    text-align: right;
  }
}
</style>
